module.exports = __webpack_public_path__ + "img/free03_800x400.f6f47b91.jpg";